export abstract class Fonts {
    static readonly BENGALY_BOLD: string = 'AGBengaly-Bold';
    static readonly BENGALY_NORMAL: string = 'AGBengaly-Normal';
    static readonly MYRIADPRO_BOLD: string = 'MYRIADPRO-BOLD';
    static readonly MYRIADPRO_REGULAR: string = 'MYRIADPRO-REGULAR';
    static readonly GOTHIC_DEUTSCH: string = 'GothicDeutsch';
    static readonly ARIAL_MT: string = 'ArialMT';
}
